/**
 * The vocabulary of a Settings connect (engines T2a; spec 2026-10-01 several accounts; engines T3
 * device codes). Zod-free on purpose, like standing.ts: the frame's schema lives in
 * schemas/event-payloads.schema.ts and reads the lists below.
 */

/** Where a Settings connect is. The server says waking / browser / failed(wake); the box says every
 *  other phase. `code` (engines T3): a device-code sign-in is waiting for the person to enter its
 *  code on the vendor's page; the frame carries the page and the code. */
export const ENGINE_CONNECT_PHASES = ['waking', 'browser', 'sign_in', 'code', 'checking', 'connected', 'failed', 'cancelled'] as const;

/** Why a Settings connect failed. Each one is a line of copy on the web, so a new reason is a
 *  new line there too. */
export const ENGINE_CONNECT_FAILURES = [
  'wake_failed',
  'no_credits',
  'computer_not_ready',
  'sign_in_timeout',
  'sign_in_failed',
  'busy',
  // Several accounts (spec 2026-10-01): the sign-in landed on an account another slot already
  // holds. The box signs the new slot out and deletes it.
  'duplicate_account',
  // Engines T3: the vendor refused a device-code sign-in because the person has codes turned off
  // for their account (its structured refusal; any other refusal is sign_in_failed).
  'device_code_disabled',
] as const;
